const initialState = {};

const profileReducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case "SET_PROFILE_DATA":
      return payload;
    case "RESET_PROFILE_DATA":
      return initialState;
    default:
      return state;
  }
};

export default profileReducer;
